import { createFileRoute } from '@tanstack/react-router'
import { KnowledgeList } from '@thom/folio-ui/pages/knowledge'

export const Route = createFileRoute('/_authenticated/knowledge/')({
	component: () => (
		<div className='mx-auto w-full max-w-5xl'>
			<KnowledgeList />
		</div>
	),
})
